import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'contacts-name',
  templateUrl: './contacts-name.component.html',
  styleUrls: ['./contacts-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsNameComponent extends BaseResizableComponent {
  @Input() loading: boolean = false;
}
